module.exports = __webpack_public_path__ + "static/img/rotate09.8c5ee41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate09.png
// module id = FV2P
// module chunks = 1